const THEME_SWITCHER_SELECTOR = ".js-theme-switcher";

export const initThemeSwitcher = () => {
    const switcher = document.querySelector(THEME_SWITCHER_SELECTOR);

    if(!switcher) return;
    const themeClass = switcher.dataset.class;

    switcher?.addEventListener('change', () => {
        if(switcher.checked) {
            document.body.classList.add(themeClass);
        } else {
            document.body.classList.remove(themeClass);
        }
    })
};

initThemeSwitcher();